/** Palestine +970 — local 059 309 4894 → wa.me/970593094894 */
export const WHATSAPP_URL = "https://wa.me/972593094894";
